// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__ftZIN","lock":"styles_lock__3Ozj6","slideInSearchBar":"styles_slideInSearchBar__XPcnM"};